/**
 * Zentrale Utility-Funktionen für Benutzer-Rollen.
 * Ersetzt redundante lokale Implementierungen in Layout, UsersPage und ProfilePage.
 */

/** Gibt ein lesbares Label für die Benutzerrolle zurück */
export const getRoleLabel = (role: string): string => {
  const labels: Record<string, string> = {
    GLOBAL_ADMIN: 'Global Admin',
    ADMIN: 'Administrator',
    AGENT: 'Agent',
  };
  return labels[role] || role;
};

/** Gibt die MUI-Farbe für eine Benutzerrolle zurück */
export const getRoleColor = (role: string): 'secondary' | 'primary' | 'default' => {
  const colors: Record<string, 'secondary' | 'primary' | 'default'> = {
    GLOBAL_ADMIN: 'secondary',
    ADMIN: 'primary',
    AGENT: 'default',
  };
  return colors[role] || 'default';
};
